<template>
  <div class="mb-4 lg:cursor-none" v-if="excerpt && full" @click="expandPanel">
    <div
      @mousemove="changeCursor()"
      @mouseleave="leaveCursor('')"
      v-if="!expand && count > 250"
      v-html="excerpt"
    ></div>
    <div
      @mousemove="changeCursor()"
      @mouseleave="leaveCursor('')"
      v-else
      v-html="full"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    excerpt: String,
    full: String,
    count: Number,
  },
  data() {
    return {
      expand: false,
    };
  },
  mounted() {
    this.$root.$on("expandText", this.toggle);
  },
  methods: {
    expandPanel() {
      if (this.expand) {
        this.expand = false;
        this.$emit("expandPanel", false);
        this.$root.$emit("changeCursor", "MORE");
      } else {
        this.expand = true;
        this.$emit("expandPanel", true);
        this.$root.$emit("changeCursor", "LESS");
      }
    },
    toggle() {
      this.expand = !this.expand;
    },
    leaveCursor(name) {
      this.$root.$emit("changeCursor", name);
    },
    changeCursor() {
      if (this.expand) {
        this.$root.$emit("changeCursor", "LESS");
      } else {
        this.$root.$emit("changeCursor", "MORE");
      }
    },
  },
};
</script>

<style scoped></style>
